import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify, {
  theme: {
    primary: '#409eff',
    info: '#909399',
    success: '#13ce66',
    warning: '#ff9800',
    error: '#ff4949',

    accent: '#409eff',

    cy_purple: '#6e45e2',
    cy_blue: '#88d3ce',

    title_color: '#3d4060',

    ...Vuetify.theme
  }
});
